import styled from "styled-components";
import { Ethereum } from "styled-icons/simple-icons";

import { AbstractConnector } from "@web3-react/abstract-connector";
import { useWeb3React } from "@web3-react/core";

import EthLogo from "../../assets/eth-logo.svg";
import {
  connectorLogosByName,
  ConnectorNames,
  connectorsByName
} from "../../connectors";
import { Interface, Text } from "../../theme/components";

const Modal = styled.div`
	position: absolute;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	top: 0;
	left: 0;
	overflow: hidden;
	background-color: rgb(0, 0, 0, 0.6);
	z-index: 100;
`

const WalletButton = styled.button`
	height: auto;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	min-width: fit-content;
	min-height: 50px;
	border-radius: 0.5rem;
	padding: 0 1rem 0 1rem;
	margin: 0.5rem 0 0.5rem 0;
	box-sizing: border-box;
	color: ${({ theme }) => theme.black};
	font-size: 12pt;
	border: 2px solid ${({ theme }) => theme.bg5};

	:hover {
		cursor: pointer;
		border: 2px solid ${({ theme }) => theme.primary1};
	}
`

const WalletsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	width: 250px;
	height: auto;
	box-sizing: border-box;
	background-color: ${({ theme }) => theme.white};
	padding: 0.5rem 1rem 0.5rem 1rem;
	border-radius: 0.5rem;
`

export interface Props {
	tryActivation: (connector: AbstractConnector | undefined) => void
}

const WalletModal = ({ tryActivation }: any) => {
	const { active } = useWeb3React()

	if (!active) {
		return (
			<Modal>
				<WalletsWrapper>
					<Interface col>
						<img alt={'eth-logo'} src={EthLogo} width={'128px'}></img>

						<Text raw primary1>
							Connect to Your Ethereum wallet
						</Text>
					</Interface>
				</WalletsWrapper>
				<br />
				<WalletsWrapper>
					{Object.keys(connectorsByName).map((name) => {
						return (
							<WalletButton
								key={name}
								onClick={async () => {
									await tryActivation(
										connectorsByName[name as keyof typeof ConnectorNames]
									)
								}}>
								{name === 'Injected' ? 'MetaMask' : name}
								<img
									width={33}
									alt={`${name as keyof typeof ConnectorNames} Logo`}
									src={
										connectorLogosByName[name as keyof typeof ConnectorNames]
									}></img>
							</WalletButton>
						)
					})}
				</WalletsWrapper>
			</Modal>
		)
	}

	return <></>
}

export default WalletModal
